export function formatFileSize(bytes: number): string {
  // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
